import symbolName from "@/util/symbol-name.mjs";

// This is a property on a catch-all route. A catch-all route is intended to match
// multiple routes, but is not supposed to be a route on its own. This is important
// for determining whether or not a route was actually matched, versus only a catch-all,
// for the purpose of showing 404 not found.
//
// It's value may either be `true`, or an array of routes for which to match on.
export const catchAllRoutes: unique symbol = symbolName("catch-all-routes");

export const EVENT_VAL_LOADING_SCREEN = "val-loading-screen";
export const EVENT_VAL_MATCH_STATS = "val-match-stats";
